import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';

import { analyticsIds } from '../../../../../../constants/analyticsIds';
import { selectCompanyId } from '../../../../../../redux/modules/company';
import { getRowValue } from '../../../../../../utils/tableUtil';

const InsuredCell = ({ row, value: insured }) => {
  const { url } = useRouteMatch();
  const companyId = useSelector(s => getRowValue(row, 'company')?.id || selectCompanyId(s));
  const project = getRowValue(row, 'project');
  const recordId = row.original.resourceId;

  if (!insured) return 'Insured Missing';

  const textProps = {
    maxW: '175px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };

  return (
    <Box _hover={{ fontWeight: '500' }} maxW="200px">
      <Link
        data-analytics-id={analyticsIds.reportsPage.insuredProfileNameLink}
        rel="noreferrer"
        style={{
          _hover: { textDecoration: 'none', outline: 'none' },
          textDecoration: 'none'
        }}
        target="_blank"
        title={insured.externalId || insured.id}
        to={url.replace(/companies.*/, `companies/${companyId}/insureds/${insured.id}/records/${recordId}`)}
      >
        <Text color="greyScale.900" {...textProps}>
          {insured.name}
        </Text>
        <Text color="greyScale.600" {...textProps}>
          {project.name}
        </Text>
      </Link>
      <Text color="grey">{getRowValue(row, 'insuredDescription')}</Text>
    </Box>
  );
};

export default InsuredCell;
